// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";

function getDecodedRecordAction(payload) {
  var match = payload.actionType;
  switch (match) {
    case "bulk_upload_wallet_transactions" :
        return /* BulkUploadWalletTransactions */0;
    case "soft assign" :
        return /* SoftAssign */{
                _0: {
                  orderId: Json_decode.field("order_id", Json_decode.string, payload.propPayload),
                  msisdn: Json_decode.field("msisdn", Json_decode.string, payload.propPayload)
                }
              };
    default:
      return /* Blank */1;
  }
}

export {
  getDecodedRecordAction ,
  
}
/* No side effect */
